import Vue from 'vue';
import http from './http_services';
import store from '../store';

const instances = {
	state: {
		instanceid: 0,
    instance_periods: [],
    instance_data: {},
    timezone_offset: '-0400',
    active_instance_period: 'Event not started',
    active_instance_updated: false
	},

  get_current_instanceid: function() {
    return this.state.instanceid;
  },

  get_current_instance_periods: function() {
    return this.state.instance_periods;
  },

  get_current_timezone_offset: function() {
    return this.state.timezone_offset;
  },

  get_specific_instance_period: function(period_label) {
    let vm = this;
    let instance = {};
    
    for(var i=0, l=vm.state.instance_periods.length;i<l;i++) {
      if(vm.state.instance_periods[i].label.toUpperCase() == period_label.toUpperCase()) {
        instance = vm.state.instance_periods[i];
      }
    }

    return instance;
  },

  get_current_instance_data: function() {
    return this.state.instance_data;
  },

  get_current_active_instance_period: function() {
    return this.state.active_instance_period;
  },

  get_active_instance_period: function() {
    let vm = this;
    let default_period_text = 'Event not started';
    let active_instance_period = default_period_text;

    if(vm.state.instance_periods.length != 0) {
      let today = new Date();

      for(let i=0, l=vm.state.instance_periods.length;i<l;i++) {
        let test_start_date = new Date(vm.state.instance_periods[i].start);
        let test_stop_date = new Date(vm.state.instance_periods[i].stop);

        // CHECK IF THE START DATE HAS ELAPSED
        if(test_start_date >= today) {
          // START DATE IS IN THE FUTURE AND HAS NOT ELAPSED

          // DO NOT START THIS PERIOD
          // console.log('test_start_date: ', test_start_date);
        }
        else {
          // START DATE IS IN THE PAST AND HAS ELAPSED

          // CHECK IF STOP DATE HAS ELAPSED
          if(test_stop_date >= today) {
            // STOP DATE IS IN THE FUTURE AND HAS NOT ELAPSED

            // START THIS PERIOD
            active_instance_period = vm.state.instance_periods[i].label;
          }
          else {
            // STOP DATE IS IN THE PAST AND HAS ELAPSED

            // DO NOT START THIS PERIOD
          }
        }
      }

      // IF PERIOD STILL NOT SET, CHECK IF OVERALL EVENT HAS STARTED OR COMPLETED
      if(active_instance_period == default_period_text) {
        for(let i=0, l=vm.state.instance_periods.length;i<l;i++) {

          // CHECK IF FIRST PERIOD (NOMINATION PERIOD) HAS STARTED
          if(vm.state.instance_periods[i].label == 'Nomination Period') {
            let test_start_date = new Date(vm.state.instance_periods[i].start);
            let test_stop_date = new Date(vm.state.instance_periods[i].stop);

            // CHECK IF EVENT STARTED
            if(test_start_date > today) {
              // EVENT HAS NOT YET STARTED

              // ADJUST PERIOD LABEL
              active_instance_period = 'Event not started';
            }
          }

          // CHECK IF LAST EVENT (WINNERS PERIOD) HAS COMPLETED
          if(vm.state.instance_periods[i].label == 'Winners Period') {
            let test_start_date = new Date(vm.state.instance_periods[i].start);
            let test_stop_date = new Date(vm.state.instance_periods[i].stop);

            // CHECK IF EVENT ENDED
            if(test_stop_date < today) {
              // EVENT HAS NOT YET STARTED

              // ADJUST PERIOD LABEL
              active_instance_period = 'Event has ended';
            }
          }
        }
      }

    }

    // SET CURRENT PERIOD
    Vue.set(vm.state, 'active_instance_period', active_instance_period);
    Vue.set(vm.state, 'active_instance_updated', true);

  },

  get_client_instance_data: function() {
    let vm = this;

    vm.fetch_client_instanceid()
      .then(function(response) {
        // console.log('get_client_instance_data response: ', response);
        // RECORD INSTANCE ID
        Vue.set(vm.state, 'instanceid', response.data.data[0].instanceid);

        // GET INSTANCE DATA
        return vm.fetch_instance_data();
      })
      .then(function(response) {
        // console.log('response: ', response);

        // RECORD INSTANCE DATA
        Vue.set(vm.state, 'instance_data', response.data.data[0]);

        // GET TIMEZONE DATA
        return vm.fetch_timezone_data();
      })
      .then(function(response) {

        // CONVERT OFFSET FROM SECONDS TO HOURS
        let offset = response.data.data.offset;
        offset = (offset / 60) / 60;

        // MAKE OFFSET A STRING
        let posneg = '-';
        if(offset >= 0) {
          posneg = '+';
        }
        offset = posneg + '0' + Math.abs(offset) + '00';

        // RECORD OFFSET
        Vue.set(vm.state, 'timezone_offset', offset);

        // GET INSTANCE PERIODS
        return vm.fetch_instance_periods();
      })
      .then(function(response) {
        // console.log('response: ', response);
        // RECORD INSTANCE PERIODS
        Vue.set(vm.state, 'instance_periods', response.data.data);
      })
      
      .then(function() {
        vm.get_active_instance_period();
      })
  },

  get_instance_periods: function() {
    let vm = this;

    vm.fetch_instance_periods()
      .then(function(response) {
        Vue.set(vm.state, 'instance_periods', response.data.data);
      })
  },

  set_active_instance_period: function(new_period) {
    let vm = this;
    Vue.set(vm.state, 'active_instance_period', new_period);
  },

  fetch_client_instanceid: function() {
    let vm = this;
    let requested_set = 'client_instanceid';

    return http.get_api_data(requested_set, {clientid: store.state.clientid});
  },

  fetch_instance_periods: function() {
    let vm = this;
    let requested_set = 'instance_periods';

    return http.get_api_data(requested_set, {instanceid: vm.get_current_instanceid()});
  },

  fetch_instance_data: function() {
    let vm = this;
    let requested_set = 'instance_data';

    return http.get_api_data(requested_set, {instanceid: vm.get_current_instanceid()});
  },

  fetch_timezone_data: function() {
    return http.get_timezone_data();
  }

}

export default instances


// WEBPACK FOOTER //
// ./src/store/modules/mod_instances.js